
interface IHardware {
    ID: string;
    Name: string;
    Kind: string | null;
    Family: string | null;
    Side: string | null;
    Reference: string;
}

export default IHardware;
